import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, ErrorHandler } from '@angular/core';
import {
  IFilterPaginationDto,
  IAdminOrderDto,
  IOrderDto,
  IPaidOrderDto,
  IOutletStatusDto,
} from '../models';

@Injectable()
export class DiagnosticService extends ApiService {
  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }

  public getoutletStatusList(
    id: number,
    model: IFilterPaginationDto,
  ): Observable<IOutletStatusDto[]> {
    return this.post(`admin/diagnostic/list/outlet/${id}`, model);
  }

  public getPaidOrderList(
    id: number,
    model: IFilterPaginationDto,
  ): Observable<IAdminOrderDto[]> {
    return this.post(`admin/diagnostic/list/paid/${id}`, model);
  }

  public getUnpaidOrderList(
    id: number,
    model: IFilterPaginationDto,
  ): Observable<IAdminOrderDto[]> {
    return this.post(`admin/diagnostic/list/unpaid/${id}`, model);
  }

  public getPendingOrderList(
    id: number,
    model: IFilterPaginationDto,
  ): Observable<IAdminOrderDto[]> {
    return this.post(`admin/diagnostic/list/pending/${id}`, model);
  }

  public getUnpaidOrder(id: number): Observable<IOrderDto> {
    return this.get(`admin/diagnostic/detail/unpaid/${id}`);
  }

  public getPaidOrderReport(
    id: number,
    model: IFilterPaginationDto,
  ): Observable<IPaidOrderDto[]> {
    return this.post(`admin/diagnostic/report/paid/${id}`, model);
  }

  public getUnpaidOrderReport(
    id: number,
    model: IFilterPaginationDto,
  ): Observable<IPaidOrderDto[]> {
    return this.post(`admin/diagnostic/report/unpaid/${id}`, model);
  }
}
